"use client";

import React, {
  createContext,
  Dispatch,
  SetStateAction,
  useContext,
  useState,
} from "react";
import { LeadFlowType } from "@/types/LeadFlowType";

type LeadModalContextType =
  | undefined
  | {
      flow: null | LeadFlowType;
      setFlow: Dispatch<SetStateAction<LeadFlowType | null>>;
    };

const LeadModalContext = createContext<LeadModalContextType>(undefined);

export function LeadModalProvider({ children }: { children: React.ReactNode }) {
  const [flow, setFlow] = useState<null | LeadFlowType>(null);
  return (
    <LeadModalContext.Provider
      value={{
        flow,
        setFlow,
      }}
    >
      {children}
    </LeadModalContext.Provider>
  );
}

export function useLeadModal() {
  const context = useContext(LeadModalContext);

  if (!context)
    throw new Error("leadModal must be used inside a `LeadModalProvider`");

  return context;
}
